/* eslint-disable no-use-before-define */
/* eslint-disable simple-import-sort/imports */
/* eslint-disable react/no-array-index-key */
import React, { useContext } from 'react';
import { Button, Typography, Radio, RadioGroup, FormControlLabel, FormControl } from '@material-ui/core';
import { AdminTestContext } from '@orientaction/Context';
import NoResponse from './NoResponse';
import ResponseItem from './ResponseItem';
import style from './style';

const ResponsesSection = ({ responses }: any) => {
  const { test, updateTest } = useContext<any>(AdminTestContext);

  const classes = style();

  const handleClick = () => {
    updateTest({
      responseAglomerationDrawerOpen: true,
      questionAglomerationToCreate: {
        ...test.questionAglomerationToCreate,
      },
    });
  };

  const handleResponseTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateTest({
      questionAglomerationToCreate: {
        ...test.questionAglomerationToCreate,
        responseType: event.target.value,
      },
    });
  };

  const responseType = test?.questionAglomerationToCreate?.responseType || 'text';
  const isImageMode = responseType === 'image';
  const canAddResponse = !isImageMode || responses?.length < 8;

  return (
    <div className={classes.mainContainer}>
      <hr className={classes.separator} />
      <div>
        <Typography className={classes.responsetitle} component="h3">
          RÉPONSES
        </Typography>
      </div>

      <div className={classes.responseTypeContainer}>
        <Typography className={classes.responseTypeTitle} component="h4">
          Type de réponse
        </Typography>
        <FormControl component="fieldset">
          <RadioGroup
            row={true}
            value={responseType}
            onChange={handleResponseTypeChange}
            className={classes.radioGroup}
          >
            <FormControlLabel
              value="text"
              control={<Radio color="primary" />}
              label="Texte"
              className={classes.radioButton}
            />
            <FormControlLabel
              value="image"
              control={<Radio color="primary" />}
              label="Images (8 max.)"
              className={classes.radioButton}
            />
          </RadioGroup>
        </FormControl>
      </div>

      {responses?.length ? (
        <div className={classes.responsesContainer}>
          {responses
            .sort((a: any, b: any) => a.order - b.order)
            .map((response: any, index: number) => (
              <div key={index} className={classes.itemContainer}>
                <ResponseItem index={index} response={response} />
              </div>
            ))}
        </div>
      ) : (
        <NoResponse />
      )}

      {canAddResponse && (
        <div className={classes.buttonContainer}>
          <Button variant="outlined" className={classes.button} onClick={handleClick}>
            Ajouter une réponse
          </Button>
        </div>
      )}
    </div>
  );
};

export default ResponsesSection;
